import { Column, Grid, Row } from "@1js/pl-card-components";
import * as React from "react";
import { SectionTitle } from "../../components/SectionTitle/SectionTitle.web";
import { VideoCarousel } from "../../components/VideoCarousel/VideoCarousel.web";
import type { Video } from "../../components/VideoCarousel/VideoCarousel.web.data";

export const VideoCarouselSection: React.FC<{
  title: string;
  videos: Video[];
  locale: string;
}> = ({ videos, title, locale }) => {
  return (
    <Grid testid="video">
      <Row>
        <Column size={12}>
          <SectionTitle title={title} />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <VideoCarousel videos={videos} locale={locale} />
        </Column>
      </Row>
    </Grid>
  );
};
